import { RadioButton, RadioGroup } from '../../../shared/common/RadioGroup';
import React, { Fragment } from 'react';
import { RenewalType, RenewalTypes } from '../utils/renewalTableTileTypes';
import { HelpTooltip } from '../../../shared/common/HelpTooltip';
import { useTranslation } from 'react-i18next';

interface Props {
    selectedType: RenewalType;
    types: RenewalTypes[];
    handleTypeChange: (type: string) => void;
}

export const RenewalLineType = ({ selectedType, types, handleTypeChange }: Props) => {
    const { t } = useTranslation();
    return (
        <td className="renewal-line-type">
            <RadioGroup
                isInline={false}
                value={selectedType}
                onChange={newValue => handleTypeChange(newValue as RenewalType)}
                className="add-to-selector-buttons"
            >
                <Fragment>
                    {types?.map(({ type, label, selected, usageLimit, enabled, infoMessage }) => (
                        <RadioButton
                            value={type}
                            selectedClassName={selected ? 'selected' : ''}
                            key={type}
                            className={type === RenewalType.DONT_RENEW ? 'danger' : ''}
                            disabled={!enabled}
                        >
                            <span>
                                {t(`shop.subscriptions.renewalType.${label}`, {
                                    count: usageLimit ? `(${usageLimit})` : ('' as any)
                                })}
                            </span>
                            {!enabled && infoMessage ? <HelpTooltip text={infoMessage} /> : null}
                        </RadioButton>
                    ))}
                </Fragment>
            </RadioGroup>
        </td>
    );
};
